import action from 'app/lib/action';
import { LOGOUT } from '../constants/actionTypes';

const logout = () => action(LOGOUT)();

export default logout;